module.exports = __webpack_public_path__ + "img/f4.43e1df04.png";